import type { SchemaType } from '@based/schema'
import { SchemaToType } from './utils'

export const SERVICE_PROVIDER_FEATURES = {
  overview: 'overview',
  events: 'events',
  developmentAreas: 'developmentAreas',
  concepts: 'concepts',
  initiatives: 'initiatives',
  knowledgeHub: 'knowledgeHub',
  current: 'current',
} as const

export type ServiceProviderFeatures = keyof typeof SERVICE_PROVIDER_FEATURES

export const REGIONS_MUNICIPALITIES_FEATURES = {
  overview: 'overview',
  discussion: 'discussion',
  initiatives: 'initiatives',
  current: 'current',
  locations: 'locations',
  knowledgeHub: 'knowledgeHub',
  developmentAreas: 'developmentAreas',
  stepByStep: 'stepByStep',
  subsidies: 'subsidies',
  experts: 'experts',
} as const

export type RegionsMunicipalitiesFeatures =
  keyof typeof REGIONS_MUNICIPALITIES_FEATURES

export const HOUSING_FORM_FEATURES = {
  overview: 'overview',
  thread: 'thread',
  initiatives: 'initiatives',
  plots: 'plots',
  knowledgeHub: 'knowledgeHub',
  current: 'current',
  popularHousingForms: 'popularHousingForms',
  experts: 'experts',
} as const

export type HousingFormFeatures = keyof typeof HOUSING_FORM_FEATURES

export const FEATURE_TOGGLE_IDENTIFIERS = {
  ...SERVICE_PROVIDER_FEATURES,
  ...REGIONS_MUNICIPALITIES_FEATURES,
  ...HOUSING_FORM_FEATURES,
} as const

export type FeatureToggleIdentifier = keyof typeof FEATURE_TOGGLE_IDENTIFIERS

export const featureToggle = {
  uuid: { type: 'alias', format: 'UUID' },
  identifier: Object.values(FEATURE_TOGGLE_IDENTIFIERS),
  description: { type: 'string' },
  entityType: { type: 'string' },
  enabled: { type: 'boolean' },
  serviceProviders: {
    items: { ref: 'serviceProvider', prop: 'featureToggles' },
  },
  regions: {
    items: { ref: 'region', prop: 'featureToggles' },
  },
  municipalities: {
    items: { ref: 'municipality', prop: 'featureToggles' },
  },
  housingForms: {
    items: { ref: 'housingForm', prop: 'featureToggles' },
  },
  createdAt: { type: 'timestamp', on: 'create' },
  updatedAt: { type: 'timestamp', on: 'update' },
} satisfies SchemaType

export type FeatureToggle = SchemaToType<typeof featureToggle> & {
  id: number
}
